import { Card, Badge, Button } from 'react-bootstrap'

function ModelCard({ model, onAdd, onRemove, showStats = false }) {
  const formatPrice = (price) => {
    if (!price) return 'N/A'
    return `$${parseFloat(price).toFixed(6)}`
  }

  return (
    <Card className="h-100">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Card.Title className="h6 mb-0">{model.name}</Card.Title>
          <Badge bg={model.active ? 'success' : 'secondary'}>
            {model.active ? 'Actif' : 'Inactif'}
          </Badge>
        </div>

        <Card.Subtitle className="mb-2 text-muted small">
          {model.provider} • {model.code}
        </Card.Subtitle>

        <div className="small mb-3">
          <div className="d-flex justify-content-between">
            <span className="text-muted">Input:</span>
            <span>{formatPrice(model.input_price_usd)}/1K tok</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted">Output:</span>
            <span>{formatPrice(model.output_price_usd)}/1K tok</span>
          </div>
          {model.context_window && (
            <div className="d-flex justify-content-between">
              <span className="text-muted">Context:</span>
              <span>{model.context_window}</span>
            </div>
          )}
        </div>

        {showStats && model.stats && (
          <div className="small border-top pt-2 mb-3">
            <div className="d-flex justify-content-between">
              <span className="text-muted">Utilisations:</span>
              <span>{model.stats.usage_count || 0}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Coût (mois):</span>
              <span>{(model.stats.monthly_cost || 0).toFixed(2)} €</span>
            </div>
          </div>
        )}

        <div className="d-grid gap-2">
          {model.active ? (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => onRemove?.(model)}
            >
              Désactiver
            </Button>
          ) : (
            <Button
              variant="primary"
              size="sm"
              onClick={() => onAdd?.(model)}
            >
              Ajouter à l'infra
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}

export default ModelCard
